import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheck, Users, Lock, Award } from 'lucide-react';
export function TrustedNetwork() {
  const pillars = [{
    icon: Users,
    title: 'Dedicated Partnership',
    desc: 'We are not transactional recruiters. We are your strategic career partners, invested in your long-term success.'
  }, {
    icon: ShieldCheck,
    title: '100% Placement Commitment',
    desc: 'We work relentlessly until you are placed. Our engagement does not end until you secure the role you deserve.',
    featured: true
  }, {
    icon: Lock,
    title: 'Confidential Process',
    desc: 'Your privacy is paramount. We navigate the market with absolute discretion, protecting your current position.'
  }];
  return <Section background="navy" className="relative overflow-hidden py-24" data-id="element-484">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-accent-400/5 rounded-full blur-3xl pointer-events-none" data-id="element-485" />

      <div className="relative z-10 max-w-6xl mx-auto" data-id="element-486">
        <FadeIn className="text-center mb-16" data-id="element-487">
          <div className="inline-flex items-center justify-center px-4 py-1.5 rounded-full border border-accent-400/30 bg-accent-400/10 mb-6 backdrop-blur-sm" data-id="element-488">
            <Award className="w-4 h-4 text-accent-400 mr-2" data-id="element-489" />
            <span className="text-xs font-bold uppercase tracking-widest text-accent-400" data-id="element-490">
              The Boardline Promise
            </span>
          </div>

          <h2 className="text-3xl md:text-5xl font-serif text-sage-50 mb-6" data-id="element-491">
            Our Placement Guarantee
          </h2>

          <p className="text-lg text-sage-300 max-w-2xl mx-auto leading-relaxed" data-id="element-492">
            When you partner with Boardline Executive Advisory, we don't stop
            until you're placed. We stand behind every client with the full
            weight of our expertise, network, and reputation.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch" data-id="element-493">
          {pillars.map((pillar, index) => <FadeIn key={index} delay={index * 0.1} className={`relative flex flex-col ${pillar.featured ? 'md:-mt-4 md:-mb-4 z-10' : ''}`} data-id="element-494">
              <div className={`
                  h-full p-8 flex flex-col items-center text-center transition-all duration-300
                  ${pillar.featured ? 'bg-ink-800 border-t-4 border-accent-400 shadow-2xl shadow-black/50 scale-105' : 'bg-ink-900/50 border border-white/10 hover:border-white/20 hover:bg-ink-800/50'}
                `} data-id="element-495">
                {pillar.featured && <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-accent-400 text-ink-900 text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded-sm" data-id="element-496">
                    Most Valued
                  </div>}

                <div className={`
                  w-16 h-16 rounded-full flex items-center justify-center mb-6
                  ${pillar.featured ? 'bg-accent-400/20 text-accent-400' : 'bg-white/5 text-sage-300'}
                `} data-id="element-497">
                  <pillar.icon className="w-8 h-8" data-id="element-498" />
                </div>

                <h3 className={`text-xl font-serif font-bold mb-4 ${pillar.featured ? 'text-white' : 'text-sage-100'}`} data-id="element-499">
                  {pillar.title}
                </h3>

                <p className="text-sage-400 text-sm leading-relaxed" data-id="element-500">
                  {pillar.desc}
                </p>

                {pillar.featured && <div className="mt-8 w-full pt-8 border-t border-white/10" data-id="element-501">
                    <p className="text-accent-400 text-xs font-bold uppercase tracking-widest" data-id="element-502">
                      Guaranteed Results
                    </p>
                  </div>}
              </div>
            </FadeIn>)}
        </div>
      </div>
    </Section>;
}